/// <amd-module name="Dashboards/WidgetHost/HostImplementation/KeyboardHandler" />
import { DashboardWidgetProps } from "Dashboards/WidgetContracts/Internal/DashboardWidgetProps";
import { GridItemPosition } from "Dashboards/WidgetContracts/Internal/WidgetHostProps";

export function getUpdatedWidgetPosition(event: React.KeyboardEvent, widgetProps: DashboardWidgetProps): GridItemPosition[] {
        let newGridData: GridItemPosition[] = [];
        switch(event.key){
            case "ArrowUp":
                newGridData.push({
                    id: widgetProps.id,
                    row: widgetProps.position.row - 1,
                    rowSpan: widgetProps.size.rowSpan,
                    column: widgetProps.position.column,
                    columnSpan: widgetProps.size.columnSpan
                } as GridItemPosition);
                break;
            case "ArrowDown": 
                newGridData.push({
                    id: widgetProps.id,
                    row: widgetProps.position.row + 1,
                    rowSpan: widgetProps.size.rowSpan,
                    column: widgetProps.position.column,
                    columnSpan: widgetProps.size.columnSpan
                } as GridItemPosition);
                break;
            case "ArrowRight":
                newGridData.push({
                    id: widgetProps.id,
                    row: widgetProps.position.row,
                    rowSpan: widgetProps.size.rowSpan,
                    column: widgetProps.position.column + 1,
                    columnSpan: widgetProps.size.columnSpan
                } as GridItemPosition);
                break;
            case "ArrowLeft":
                newGridData.push({
                    id: widgetProps.id,
                    row: widgetProps.position.row,
                    rowSpan: widgetProps.size.rowSpan,
                    column: widgetProps.position.column - 1,
                    columnSpan: widgetProps.size.columnSpan
                } as GridItemPosition);
              
        }

    return newGridData;
}
